import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1c58b452"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fp" }
const _hoisted_2 = { class: "fp__elm" }
const _hoisted_3 = { class: "fp__elm-switcher" }
const _hoisted_4 = {
  key: 0,
  class: "fp__bc"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp__bc-label" }, "Баланс", -1))
const _hoisted_6 = { class: "fp__bc-value" }
const _hoisted_7 = {
  key: 1,
  class: "fp__bc"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp__bc-label" }, "Купленных каналов", -1))
const _hoisted_9 = { class: "fp__bc-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fp__line" }, null, -1))
const _hoisted_11 = { class: "fp__amount" }
const _hoisted_12 = { class: "fp__amount-wrap" }
const _hoisted_13 = { class: "fp__amount-wrap-label" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "fp__amount-wrap-select" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconWhatsApp = _resolveComponent("IconWhatsApp")!
  const _component_UiNumberInput = _resolveComponent("UiNumberInput")!
  const _component_UiNumberSelect = _resolveComponent("UiNumberSelect")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBalance && _ctx.onClickBalance(...args))),
          class: _normalizeClass(
						_ctx.isChecked
							? 'fp__elm-switcher-on-left'
							: 'fp__elm-switcher-off'
					)
        }, " Баланс ", 2),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickChannel && _ctx.onClickChannel(...args))),
          class: _normalizeClass(
						!_ctx.isChecked
							? 'fp__elm-switcher-on-right'
							: 'fp__elm-switcher-off'
					)
        }, " Каналы ", 2)
      ])
    ]),
    (_ctx.isChecked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatBalance(_ctx.payGetBalance)), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_IconWhatsApp, { class: "fp__bc-value-icon" }),
            _createTextVNode(" " + _toDisplayString(_ctx.payActivatedChannels.count), 1)
          ])
        ])),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_ctx.isChecked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, "Сумма пополнения"))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, "Купить каналы WhatsApp"))
        ]),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.isChecked)
            ? (_openBlock(), _createBlock(_component_UiNumberInput, {
                key: 0,
                label: "Введите сумму",
                "is-error": _ctx.isInputBalanceError,
                onInputBalance: _ctx.onInputBalance
              }, null, 8, ["is-error", "onInputBalance"]))
            : (_openBlock(), _createBlock(_component_UiNumberSelect, {
                key: 1,
                total: 100,
                "default-value": 1,
                onSelectedValue: _ctx.selectedAmountChannels
              }, null, 8, ["onSelectedValue"]))
        ]),
        (_ctx.isChecked)
          ? (_openBlock(), _createBlock(_component_UiButton, {
              key: 0,
              class: "fp__amount-wrap-btn",
              onClick: _ctx.onClickToUpBalance,
              label: "Пополнить",
              "background-color": "var(--theme-color)",
              "border-color": "var(--theme-color)",
              color: "rgb(255, 255, 255)",
              "font-weight": "600",
              "font-size": "16px"
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_UiButton, {
              key: 1,
              class: "fp__amount-wrap-btn",
              onClick: _ctx.onClickPayChannels,
              label: 'Оплатить ' + _ctx.formatBalance(_ctx.channelCost),
              "background-color": "var(--theme-color)",
              "border-color": "var(--theme-color)",
              color: "rgb(255, 255, 255)",
              "font-weight": "600",
              "font-size": "16px"
            }, null, 8, ["onClick", "label"]))
      ])
    ])
  ]))
}